import {
  SalesforceActions,
  SalesforceAutomation,
  SalesforceAutomationLocalData,
} from 'module/api/integrations/salesforce/types';

export const transformApiToSfFormat = (
  automation: SalesforceAutomation,
): Partial<SalesforceAutomationLocalData> => {
  const mainAction = automation.actions?.[0];
  const contactAction = automation.actions?.[1];
  const salesForceType = mainAction?.resourceType;

  const triggers = automation.triggerCondition;

  const matches = automation.matchingCondition;

  // Extract fields based on action type
  let rocketlaneFields = {};
  let accountFields = {};
  let contactFields = {};
  let sourceResourceType: string | undefined;
  let sourceRelationshipName: string | undefined;
  let sourceParentResourceId: string | undefined;
  let sourceParentResourceType: string | undefined;
  let sourceParentResourceFieldId: string | undefined;

  if (salesForceType === SalesforceActions.Project && mainAction) {
    // Project fields are in the main action inputs
    rocketlaneFields = Object.keys(mainAction.inputs || {}).reduce(
      (acc, key) => {
        const value = mainAction.inputs[key];

        if (key === 'teamMembers') {
          return { ...acc, [key]: value };
        }

        return {
          ...acc,
          [key]: { valueStr: value as string },
        };
      },
      {},
    );

    // Account fields are in dependent actions
    const accountAction = mainAction.dependentActions?.[0];

    if (accountAction) {
      accountFields = Object.keys(accountAction.inputs || {}).reduce(
        (acc, key) => {
          const value = accountAction.inputs[key];

          if (key === 'teamMembers') {
            return { ...acc, [key]: value };
          }

          return {
            ...acc,
            [key]: { valueStr: value as string },
          };
        },
        {},
      );
    }
  } else if (salesForceType === SalesforceActions.Account && mainAction) {
    // Account fields are in the main action inputs
    accountFields = Object.keys(mainAction.inputs || {}).reduce((acc, key) => {
      const value = mainAction.inputs[key];

      if (key === 'teamMembers') {
        return { ...acc, [key]: value };
      }

      return {
        ...acc,
        [key]: { valueStr: value as string },
      };
    }, {});
  }

  if (contactAction) {
    const contactActionInputs = contactAction.inputs;

    sourceResourceType = contactAction.sourceResourceType as string;
    sourceRelationshipName = contactAction.sourceRelationshipName as string;
    sourceParentResourceId = contactAction.sourceParentResourceId as string;
    sourceParentResourceType = contactAction.sourceParentResourceType as string;
    sourceParentResourceFieldId =
      contactAction.sourceParentResourceFieldId as string;

    contactFields = Object.keys(contactActionInputs || {}).reduce(
      (acc, key) => {
        const value = contactActionInputs[key];

        return {
          ...acc,
          [key]: { valueStr: value as string },
        };
      },
      {},
    );

    if (sourceResourceType && sourceRelationshipName) {
      contactFields = {
        ...contactFields,
        contactObject: {
          label: sourceResourceType,
          valueStr: sourceRelationshipName,
          valueMeta: {
            sourceResourceType,
            sourceRelationshipName,
            sourceParentResourceFieldId,
          },
        },
      };
    }

    // Extract source information for contacts
  }

  return {
    automationName: automation.automationName,
    description: automation.description,
    salesforceObject: automation.object
      ? {
        label: automation.object,
        value: automation.object,
      }
      : undefined,
    generateAutomationForFutureInserts:
      contactAction?.generateAutomationForFutureInserts ?? false,
    triggers: triggers as any,
    matches: matches as any,
    salesForceType,
    rocketlaneFields,
    accountFields,
    contactFields,
    sourceResourceType,
    sourceRelationshipName,
    sourceParentResourceId,
    sourceParentResourceType,
    sourceParentResourceFieldId,
    actions: automation.actions,
  };
};
